import React, { memo } from "react";
import PropTypes from "prop-types";
import BaseSingleCheckbox from "../../../../components/BaseSingleCheckbox";
import useCookie from "../../../../hooks/useCookie";
import "./style.scss";
import { useTranslation } from "react-i18next";

function TermsAndPrivacy({
  checkedTerms,
  checkedPrivacy,
  onCheckTerms,
  onCheckPrivacy,
}) {
  TermsAndPrivacy.propTypes = {
    checkedTerms: PropTypes.bool,
    checkedPrivacy: PropTypes.bool,
    onCheckTerms: PropTypes.func,
    onCheckPrivacy: PropTypes.func,
  };
  const { getCookie } = useCookie();
  const inviterGender = getCookie("inviterGender");
  const { t, i18n } = useTranslation();

  const isInTouch =
    typeof window !== "undefined" &&
    window.location.hostname.endsWith("in-touch.space");
  const prefix = isInTouch ? "/game" : "";
  const links = {
    en: {
      conditions: `${prefix}/conditions-payplus`,
      privacy: `${prefix}/privacy-payplus`,
    },
    ru: {
      conditions: `${prefix}/conditions`,
      privacy: `${prefix}/privacy`,
    },
  };
  const acquaintedText =
    inviterGender === "male"
      ? t("acquainted_with_female")
      : t("acquainted_with_male");
  return (
    <div>
      <BaseSingleCheckbox
        className="terms-privacy"
        checkedValue={checkedTerms}
        onCheckValue={onCheckTerms}
      >
        <div className="terms-privacy__tp">
          <span>{acquaintedText}</span>
          <a
            href={links[i18n.language].conditions}
            target="_blank"
            className="highlight terms-privacy__conditions"
            rel="noreferrer"
          >
            {t("termsAndConditions")}
          </a>
        </div>
      </BaseSingleCheckbox>
      <BaseSingleCheckbox
        className="terms-privacy"
        checkedValue={checkedPrivacy}
        onCheckValue={onCheckPrivacy}
      >
        <div className="terms-privacy__tp">
          <span>{acquaintedText}</span>
          <a
            className="highlight terms-privacy__privacy"
            href={links[i18n.language].privacy}
            target="_blank"
            rel="noreferrer"
          >
            {t("privacyPolicy")}
          </a>{" "}
          {t("and")}
          {t("data_processing")}
        </div>
      </BaseSingleCheckbox>
    </div>
  );
}

export default memo(TermsAndPrivacy);
